import { CompanyBase } from "./company-base.model";
import { UserModule } from "./user-module.model";
import { UserRole } from "./user-role.model";

export class User {
  UserId?: string;
  UserName: string;
  IsActive: boolean;
  FirstName: string;
  LastName: string;
  Email: string;
  PhoneNumber: string;
  Function: string;
  TwoFactorEnabled: boolean;
  TwoFactorSetupEnabled: boolean;
  CompanyId?: number;
  UserGroupIcon: string;
  HasSendEmailError: boolean;
  SendEmailErrorMessage: string;
  Company: CompanyBase;
  Roles: UserRole[];
  UserModules: Array<UserModule>;
  IsReadOnly: boolean;

  constructor() {
    this.UserId = null;
    this.UserName = null;
    this.IsActive = null;
    this.FirstName = null;
    this.LastName = null;
    this.Email = null;
    this.PhoneNumber = null;
    this.Function = null;
    this.TwoFactorEnabled = false;
    this.TwoFactorSetupEnabled = false;
    this.CompanyId = null;
    this.UserGroupIcon = null;
    this.HasSendEmailError = false;
    this.SendEmailErrorMessage = null;
    this.Roles = [];
    this.UserModules = new Array<UserModule>();
    this.IsReadOnly = false;
  }
}

export let UserIgnoreList: any[] = [
  'Company'
];
